const ContentWithSideBarMaxWidth = `52rem`

const ShowcaseSidebarMaxWidth = `15rem`

const BannerHeight = "3rem" // 48px

const NavHeight = {
  Default: "4rem", // 64px
}

const SidebarItemMinHeight = "2.5rem"

const SidebarUtilityHeight = "3.5rem"

const SidebarWidth = {
  default: `16.5rem`,
  large: `18rem`,
  mobile: `320px`,
}

const HeaderPaddingTopDesktop = `3rem`

const LayoutWidth = 90

// TODO: see where this is used for positioning vs other
// NB: sticky positioned header affects everything that uses this
const HeaderHeight = `${parseFloat(BannerHeight) +
  parseFloat(NavHeight.Default)}rem`

export {
  ContentWithSideBarMaxWidth,
  ShowcaseSidebarMaxWidth,
  BannerHeight,
  NavHeight,
  HeaderHeight,
  SidebarItemMinHeight,
  SidebarWidth,
  HeaderPaddingTopDesktop,
  LayoutWidth,
  SidebarUtilityHeight,
}
